import {observable, computed} from 'mobx';

import GroupScopeSettings from './GroupScopeSettings';
import * as MarkupTemplateId from 'settings/constant/MarkupTemplateId';
import * as GroupSettingsScope from 'domain/constant/GroupSettingsScope';

let key = 1;

export default class Group {
	@observable id = 0;
	@observable name = '';
	@observable markup_template_id = MarkupTemplateId.SIMPLE_GROUP;
	@observable is_shown = true;
	@observable related_feature_id = 0;
	@observable sort = 0;

	/** @type {Map<String, GroupScopeSettings>} */
	@observable scope_settings = new Map();

	_key;

	constructor(group) {
		if (group) {
			this.id = parseInt(group.id);
			this.name = group.name;
			this.markup_template_id = group.markup_template_id;
			this.is_shown = group.is_shown;
			this.related_feature_id = parseInt(group.related_feature_id);
			this.sort = parseInt(group.sort);

			this.scope_settings = new Map(group.scope_settings.map(params => [
				params.scope,
				new GroupScopeSettings(params.settings),
			]));
		}

		this._key = key++;
	}

	@computed get show_on_primary_product_only() {
		for (const settings of this.scope_settings.values()) {
			if (settings.show_on_primary_product_only) {
				return true;
			}
		}

		return false;
	}

	/**
	 * @param scope
	 * @return GroupScopeSettings
	 */
	getScopeSettings(scope) {
		if (!this.scope_settings.has(scope)) {
			this.scope_settings.set(scope, this._buildDefaultGroupScopeSettings(scope));
		}

		return this.scope_settings.get(scope);
	}

	/**
	 * @private
	 * @param scope
	 * @return GroupScopeSettings
	 */
	_buildDefaultGroupScopeSettings(scope) {
		const settings = new GroupScopeSettings();

		settings.is_shown = true;
		settings.show_in_stock_only = true;
		settings.show_on_primary_product_only = false;
		settings.show_header = true;
		settings.current_product_first = false;

		if (scope === GroupSettingsScope.CATEGORY) {
			settings.show_header = false;
			settings.current_product_first = true;
		}

		return settings;
	}
}